// Users
export const API_USERS = "/users";
export const API_USER_BY_ID = (id) => `/users/${id}`;
export const API_USER_ROLES_BY_ID = (id) => `/users/${id}/roles`;
export const API_USER_ROLE = (userId, roleId) =>
  `/users/${userId}/roleId/${roleId}`;

// Roles
export const API_ROLES = "/roles";
export const API_ROLE_BY_UD = (id) => `/roles/${id}`;
export const API_ROLE_USERS_BY_ID = (id) => `/roles/${id}/users`;
export const DROPDOWNS_ROLES = "/dropdowns/roles";

// Permissions
export const API_PERMISSIONS = "/permissions";
export const API_PERMISSIONS_BY_ID = (id) => `/permissions/${id}`;
export const DROPDOWNS_DATASETS = "/dropdowns/permissions/dataapi";
export const API_PERMISSIONS_DATAAPI = "/permissions/dataapi";
export const API_PERMISSIONS_DATAAPI_BY_ID = (id) =>
  `/permissions/dataapi/${id}`;
export const DROPDOWNS_SECTIONS =
  "/dropdowns/permissions/controlcentre/sections";
export const ADD_SECTION = (id) => `/permissions/controlcentre/sections/${id}`;
export const API_ROLE_SECTION = "/permissions/controlcentre/sections/roles";
export const CC_ROUTES = "/permissions/controlcentre/routes";
export const CC_NAVBAR_SECTIONS = "/permissions/controlcentre/navbarSections";
export const CC_ACCESS_LEVEL = "/permissions/controlcentre/accessLevel";
export const CC_ACCESS_LEVEL_BY_ID = (id) =>
  `/permissions/controlcentre/accessLevel/${id}`;
